import Dashboard from "../../../../pages/platforms/frontdesk/dashboard";

import {
  Onboard,
  Tasks,
  Reports,
} from "../../../../pages/platforms/laboratory/diagnostics";

import { Menus, Services } from "../../../../pages/platforms/cashier";
// import Products from "../../../../pages/platforms/frontdesk/market/products";
// import productsGenerics from "../../../../pages/platforms/frontdesk/market/productsGenerics";
// import machines from "../../../../pages/platforms/SuperAdmin/commerce/assets/machines";
// import generics from "../../../../pages/platforms/frontdesk/market/generics";
import mentainance from "../../../../pages/platforms/frontdesk/market/mentainance";

import Sendouts from "../../../../pages/platforms/laboratory/diagnostics/sendouts";
import Stocks from "../../../../pages/platforms/frontdesk/market/stocks";

const frontdesk = [
  {
    name: "Bulletin Board",
    icon: "tachometer-alt",
    path: "/bulletin",
    title:
      "Displays announcements and system-wide updates for the frontdesk team.",
    component: Dashboard,
  },
  {
    name: "Logistics ",
    path: "/logistics ",
    icon: "cogs",
    title:
      "Manage logistics  – onboarding, task queue, tracking, and sendouts.",
    children: [
      {
        name: "Onboarding",
        path: "/onboarding",
        icon: "tv",
        title: "Register and onboard patients for diagnostic procedures.",
        component: Onboard,
      },
      {
        name: "Delivery",
        path: "/delivery",
        icon: "clipboard-list",
        title: "View and manage pending diagnostic tasks for patients.",
        component: Tasks,
      },
      {
        name: "Distribution",
        path: "/distribution",
        icon: "file-alt",
        title: "Monitor the progress and reports of diagnostics performed.",
        component: Reports,
      },
      {
        name: "Storage",
        path: "/storage",
        icon: "tv",
        title:
          "Monitor, record, and bill sendouts to outsourced diagnostic partners.",
        component: Sendouts,
      },
    ],
  },
  {
    name: "Supply Hub",
    path: "/supply-hub",
    icon: "warehouse",
    title:
      "Centralized platform for requesting clinic supplies handled by procurement.",
    children: [
      {
        name: "Browse Supplies",
        path: "/supply-hub/browse",
        icon: "boxes",
        title: "Browse available items for internal request.",
        // component: BrowseSuppliesComponent, // ← add when available
      },
      {
        name: "My Requests",
        path: "/supply-hub/requests",
        icon: "tasks",
        title: "Track and manage your submitted supply requests.",
        children: [
          {
            name: "Submitted",
            path: "/supply-hub/requests/submitted",
            icon: "file-invoice",
            title: "Requests that are awaiting procurement action.",
            // component: SubmittedRequestsComponent,
          },
          {
            name: "To Receive",
            path: "/supply-hub/requests/to-receive",
            icon: "clipboard-list",
            title:
              "Requests that have been approved and are ready for receipt.",
            // component: ToReceiveRequestsComponent,
          },
          {
            name: "Completed",
            path: "/supply-hub/requests/completed",
            icon: "check-circle",
            title: "Requests that have been successfully received.",
            // component: CompletedRequestsComponent,
          },
          {
            name: "Cancelled",
            path: "/supply-hub/requests/cancelled",
            icon: "ban",
            title: "Requests that were withdrawn or rejected.",
            // component: CancelledRequestsComponent,
          },
        ],
      },
    ],
  },
  {
    name: "Merchandise",
    path: "/merchandise",
    icon: "boxes",
    title:
      "Manage inventory and product listings like machines, medicines, and consumables.",
    children: [
      // {
      //   name: "productsGenerics",
      //   path: "/productsGenerics",
      //   icon: "cogs",
      //   title: "List of generic categories for medical products.",
      //   component: productsGenerics,
      // },
      // {
      //   name: "products",
      //   path: "/products",
      //   icon: "cogs",
      //   title: "Inventory of available products for use or sale.",
      //   component: Products,
      // },
      // {
      //   name: "Machines",
      //   path: "/merchandise/machines",
      //   icon: "laptop-code",
      //   title: "List and manage medical machines and diagnostic equipment.",
      //   component: machines, // add your component here
      // },
      // {
      //   name: "Medicines",
      //   path: "/medicines",
      //   icon: "laptop-code",
      //   title: "Manage pharmaceutical stocks and generic drugs.",
      //   component: generics, // add your component here
      // },
      {
        name: "Mentainance",
        path: "/merchandise/mentainance",
        icon: "laptop-code",
        title: "Track machine maintenance and calibration schedules.",
        component: mentainance,
      },
      {
        name: "Stocks",
        path: "/merchandise/stocks",
        icon: "box",
        component: Stocks, // add your component here
      },
    ],
  },
  {
    name: "Catalogs",
    path: "/offers",
    icon: "list",
    children: [
      {
        name: "Menus",
        path: "/offers/menus",
        icon: "bars",
        component: Menus,
      },
      {
        name: "Services",
        path: "/offers/services",
        icon: "list",
        component: Services,
      },
      {
        name: "Products",
        path: "/offers/products",
        icon: "cogs",
        // component: products,
      },
      {
        name: "Consumables",
        icon: "tv",
        path: "/offers/consumables",
        children: [
          {
            name: "Preanalytical",
            path: "/offers/consumables/preanalytical",
            icon: "check-circle",
          },
          {
            name: "Analytical",
            path: "/offers/consumables/analytical",
            icon: "balance-scale",
          },
          {
            name: "Postanalytical",
            path: "/offers/consumables/postanalytical",
            icon: "thermometer-half",
            // component: ,
          },
        ],
      },
    ],
  },
];

export default frontdesk;
